import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskModule } from 'ngx-mask';


@Component({
    selector: 'formly-field-currency',
    standalone: true,
    imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgxMaskModule,
    FormlyModule
],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <mat-form-field class="w-full" appearance="outline" floatLabel="always">
      <mat-label>{{ to.label }}</mat-label>
      <input
        matInput
        type="text"
        [formControl]="$any(formControl)"
        [formlyAttributes]="field"
        [placeholder]="to.placeholder || to.label"
        [required]="to.required || false"
        mask="separator.{{ precision }}"
        [thousandSeparator]="thousandSeparator"
        [decimalMarker]="decimalMarker"
        [prefix]="prefix"
        [suffix]="suffix"
        [dropSpecialCharacters]="true"
        (blur)="normalizeOnBlur()"
        />
      @if (to.hint) {
        <mat-hint>{{ to.hint }}</mat-hint>
      }
      @if (showError) {
        <mat-error>
          <formly-validation-message [field]="field"></formly-validation-message>
        </mat-error>
      }
    </mat-form-field>
    `,
})
export class FormlyCurrencyTypeComponent extends FieldType {
    get precision(): number {
        return Number(this.to?.precision ?? 2);
    }
    get thousandSeparator(): string {
        return this.to?.thousandSeparator ?? ',';
    }
    get decimalMarker(): '.' | ',' | ['.', ','] {
        return (this.to?.decimalMarker ?? '.') as '.' | ',' | ['.', ','];
    }
    get prefix(): string {
        return this.to?.prefix ?? '';
    }
    get suffix(): string {
        return this.to?.suffix ?? '';
    }
    normalizeOnBlur(): void {
        const v = this.formControl.value;
        if (v === null || v === undefined || v === '') return;
        const raw = String(v).replaceAll(/[^0-9.-]/g, '');
        if (!raw || raw === '-' || raw === '.' || raw === '-.') {
            this.formControl.setValue(null);
            return;
        }
        const [intPart, decPart = ''] = raw.split('.');
        const trimmed = decPart.length > this.precision ? decPart.slice(0, this.precision) : decPart;
        const normalized = trimmed.length ? `${intPart}.${trimmed}` : intPart;
        this.formControl.setValue(normalized, { emitEvent: true });
    }
}
